/** Escalas y ticks para las gráficas (puro, sin DOM). */
export type Dominio = [number, number];

export function escalaLineal(dominio: Dominio, rango: [number, number]) {
  const [d0, d1] = dominio, [r0, r1] = rango;
  const span = d1 - d0 || 1;
  return (v: number) => r0 + ((v - d0) / span) * (r1 - r0);
}

/** Paso "bonito" (1, 2, 2.5, 5 × 10^n) para ~n ticks. */
export function pasoBonito(rango: number, n = 4): number {
  if (!Number.isFinite(rango) || rango <= 0) return 1;
  const crudo = rango / n;
  const mag = Math.pow(10, Math.floor(Math.log10(crudo)));
  const f = crudo / mag;
  const m = f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10;
  return m * mag;
}

/** Ticks redondos que cubren [min, max]. */
export function ticksBonitos(min: number, max: number, n = 4): number[] {
  if (min === max) { if (min === 0) return [0, 1]; const p = pasoBonito(Math.abs(min), n); return [Math.floor(min / p) * p, Math.ceil(max / p) * p + (min > 0 ? 0 : p)]; }
  const paso = pasoBonito(max - min, n);
  const ini = Math.floor(min / paso) * paso;
  const fin = Math.ceil(max / paso) * paso;
  const out: number[] = [];
  for (let v = ini; v <= fin + paso / 1e6; v += paso) out.push(Math.round(v / paso) * paso);
  return out;
}

/** Abreviación para ejes: 50,000,000 → "50M"; 120,000 → "120k". */
export function abreviar(v: number): string {
  const a = Math.abs(v);
  const s = v < 0 ? "−" : "";
  if (a >= 1e6) return `${s}${trim(a / 1e6)}M`;
  if (a >= 1e3) return `${s}${trim(a / 1e3)}k`;
  return `${s}${trim(a)}`;
}
const trim = (n: number) => (Math.round(n * 10) / 10).toString();
